<div [class.admin-block]="itemBlockObj.type === blockTypeEnum.Administratif" *ngIf="blockItem$|async as itemBlockObj">
  <div *ngIf="itemBlockObj.type === blockTypeEnum.Administratif" class="ttl" fxLayout="row" fxLayoutAlign="end end">Block administratif</div>
  <div fxLayout="row">
    <div fxFlex class="padding15">
      <h3 class="mat-subheader bloc__subheader">
        {{itemBlockObj?.nom}}
        <button mat-icon-button
                color="accent"
                matTooltip="Modifier le titre du bloc"
                [matTooltipPosition]="'above'"
                (click)="editBlock(itemBlockObj)">
          <i class="material-icons">mode_edit</i>
        </button>
        <button mat-icon-button
                color="warn"
                matTooltip="Supprimer"
                [matTooltipPosition]="'above'"
                (click)="onRemoveBlock(indexBlock)">
          <i class="material-icons">close</i>
        </button>
      </h3>

      <div class="dm__block"
           (cdkDropListDropped)="drop($event)"
           [cdkDropListData]="itemBlockObj.fields"
           cdkDropList
      >
        <div *ngFor="let control of itemBlockObj.fields; let indexControl = index" cdkDrag class="dm__block__body">
          <div [ngSwitch]="control.options.controlType">

            <mat-card class="element" *ngSwitchCase="fieldType.TypeText">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeText">drag_indicator</mat-icon>
              </div>
              <app-text-input
                class="content"
                [indexControl]="indexControl"
                [control]="control"
                (textInputUpdateControl)="updatedControl($event)"
                (textInputDelete)="deleteControl($event)">
              </app-text-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeLabel">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeLabel">drag_indicator</mat-icon>
              </div>
              <app-label-input
                class="content"
                [indexControl]="indexControl"
                [control]="control"
                (labelInputUpdateControl)="updatedControl($event)"
                (labelInputDelete)="deleteControl($event)">
              </app-label-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypePhone">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypePhone">drag_indicator</mat-icon>
              </div>
              <app-phone-input
                class="content"
                [indexControl]="indexControl"
                [control]="control"
                (phoneInputUpdateControl)="updatedControl($event)"
                (phoneInputDelete)="deleteControl($event)">
              </app-phone-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeEmail">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeEmail">drag_indicator</mat-icon>
              </div>
              <app-email-input
                class="content"
                [indexControl]="indexControl"
                [control]="control"
                (emailInputUpdateControl)="updatedControl($event)"
                (emailInputDelete)="deleteControl($event)">
              </app-email-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeTextarea">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeTextarea">drag_indicator</mat-icon>
              </div>
              <app-text-area-input
                class="content"
                [indexControl]="indexControl"
                [control]="control"
                (textAreaUpdateControl)="updatedControl($event)"
                (textAreaDelete)="deleteControl($event)">
              </app-text-area-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeCheckbox">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeCheckbox">drag_indicator</mat-icon>
              </div>
              <app-checkbox-radio-input
                class="content"
                [indexControl]="indexControl"
                [control]="control"
                (checkboxUpdateControl)="updatedControl($event)"
                (checkboxDelete)="deleteControl($event)">
              </app-checkbox-radio-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeRadio">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeRadio">drag_indicator</mat-icon>
              </div>
              <app-checkbox-radio-input
                class="content"
                [indexControl]="indexControl"
                [control]="control"
                (checkboxUpdateControl)="updatedControl($event)"
                (checkboxDelete)="deleteControl($event)">
              </app-checkbox-radio-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeDate">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeDate">drag_indicator</mat-icon>
              </div>
              <app-date-input
                class="content"
                [control]="control"
                [indexControl]="indexControl"
                (datepickerUpdateControl)="updatedControl($event)"
                (datepickerDelete)="deleteControl($event)">
              </app-date-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeSelect">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeSelect">drag_indicator</mat-icon>
              </div>
              <app-select-input
                class="content"
                [control]="control"
                [indexControl]="indexControl"
                (selectInputUpdateControl)="updatedControl($event)"
                (selectInputDelete)="deleteControl($event)"
              >
              </app-select-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeFile">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeFile">drag_indicator</mat-icon>
              </div>
              <app-file-input
                class="content"
                [control]="control"
                [indexControl]="indexControl"
                (fileInputUpdateControl)="updatedControl($event)"
                (fileInputDelete)="deleteControl($event)"
              >
              </app-file-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeSvcCmp">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon [attr.data-cy]="'icon-form-block-drag-indicator-'+fieldType.TypeSvcCmp">drag_indicator</mat-icon>
              </div>
              <app-svc-cmp-input
                class="content"
                [control]="control"
                [indexControl]="indexControl"
                (svcCmpInputUpdateControl)="updatedControl($event)"
                (svcCmpInputDelete)="deleteControl($event)"
              >
              </app-svc-cmp-input>
            </mat-card>

            <mat-card class="element" *ngSwitchCase="fieldType.TypeAvis">
              <div class="draggable-icon" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
              <app-avis-input
                class="content"
                [control]="control"
                [indexControl]="indexControl"
                (avisInputUpdateControl)="updatedControl($event)"
                (avisInputDelete)="deleteControl($event)"
              >
              </app-avis-input>
            </mat-card>

          </div>
        </div>
      </div></div>
    <mat-divider [vertical]="true"></mat-divider>
    <div fxLayout="column" fxFlex="5" fxLayoutAlign="center center" *ngIf="itemBlockObj.type !== blockTypeEnum.Administratif"
    style="border-bottom: 1px dotted gray">
      <button mat-icon-button color="primary"
              [disabled]="indexBlock === 0"
              matTooltipPosition="déplacer vers le haut"
              (click)="onMoveUpBlock(itemBlockObj)"
      >
        <mat-icon>arrow_upward</mat-icon>
      </button>
      <button mat-stroked-button color="primary">{{itemBlockObj?.position}}</button>
      <button mat-icon-button color="primary"
              [disabled]="lastIndexBlock"
              matTooltipPosition="déplacer vers le bas"
              (click)="onMoveDownBlock(itemBlockObj)"
      >
        <mat-icon>arrow_downward</mat-icon>
      </button>
    </div>
  </div>
</div>


